export default __webpack_public_path__ + "static/WiganBandits-d9fdcebd21b215a6edefc34850cbd0fe.jpg";